import React from "react";
import PropTypes from 'prop-types'
import {set} from 'object-path-immutable';
import AdditionalTypeFields from "./AdditionalTypeFields";
import SelectType from "../../../../../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {multiLanguageValue} from "../../../../../../../../JsonScreen/Utils/lib";
import {useSelector} from "react-redux";

const ActionType = (props) => {
    const {
        schema, action, actions, setValue,
        path, listStorage, entities, selectedComponent, contextMenu
    } = props;
    const {userLanguage} = useSelector(state => state.app);
    function onChange(value, fieldPath) {
        const isList = selectedComponent.component.type === 'list';
        if (value === 'setFilter' && isList) {
            const currentValue = findByString(actions, `${path}`);
            const newValue = set(currentValue, '', {
                destination: selectedComponent.component.properties ? selectedComponent.component.properties.name : "",
                type: value
            });
            setValue(newValue, path);
            return
        }

        setValue(value, fieldPath)
    }

    return (
        <div style={{padding: 5, flexGrow: 1}}>
            <SelectType
                showLabel={false}
                values={actions}
                labelStyles={{width: 100}}
                setValue={onChange}
                field={{
                    optLabel: "label",
                    label: "Action",
                    type: "objSelect",
                    path: `${path}.type`,
                    values: schema
                }}
            />
            <AdditionalTypeFields
                type={action.type}
                setValue={setValue}
                actions={actions}
                path={path}
                listStorage={listStorage}
                entities={entities ? entities.map(entity => multiLanguageValue(entity.properties ? entity.properties.name : '', userLanguage)) : []}
                selectedComponent={selectedComponent}
                contextList={contextMenu}
            />
        </div>
    )
};

export default ActionType

ActionType.propTypes = {
    schema: PropTypes.array,
    action: PropTypes.object,
    actions: PropTypes.array,
    setValue: PropTypes.func,
    path: PropTypes.string,
    listStorage: PropTypes.array,
    selectedComponent: PropTypes.object
};